import { usePageTracking } from '@/hooks/usePageTracking';

export const TrackingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Enable page tracking
  usePageTracking();

  return <>{children}</>;
};